import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

// 後台專用 Supabase Client：獨立 storageKey，與前台 session 完全隔離
// - storageKey 與前台 "frontend-auth-token" 不同，兩邊 localStorage 互不干擾
// - 前台 clearSupabaseSessionCache() 只清除 sb- / supabase. / frontend-auth-token，絕不碰後台 key
export const supabaseAdmin = createClient(
  supabaseUrl || "https://mock.local",
  supabaseAnonKey || "mock-key",
  {
    auth: {
      storage: typeof window !== "undefined" ? window.localStorage : undefined,
      storageKey: "backend-auth-token",
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: false,   // 後台不走 OAuth 回調，關閉避免 URL hash 干擾
      broadcastSession: false, // 禁用跨 tab session 廣播，後台完全獨立
    },
  }
);